import React from "react";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Container,
  Row,
  Col,
} from "reactstrap";

function AccordionFAQs() {
  const [openedCollapse, setOpenedCollapse] = React.useState("collapse-1");
  return (
    <div className="accordion-1">
      <Container>
        <Row>
          <Col className="mx-auto text-center" md="6">
            <h2 className="title font-weight-bold mb-3 mt-5">Frequently asked questions</h2>
          </Col>
        </Row>
        <Row>
          <Col className="ml-auto mb-5 bg-default" md="12">
            <div className="accordion" id="FAQs">
              <Card className="bg-default">
                <CardHeader className="bg-default" id="whatTypes">
                  <h3 className="text-white font-weight-bold">Intelligence Services</h3>
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-1"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-1" ? "" : "collapse-1"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      What types of intelligence services do you offer?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-1"}>
                  <CardBody className="text-white font-weight-normal">
                    We provide comprehensive intelligence solutions, leveraging human intelligence 
                    and OSINT &#40;Open Source Intelligence&#41; to spot nuanced data that AI might miss. 
                    Our services include advanced analytics, due diligence, private investigations, and 
                    threat intelligence to safeguard your assets and enhance strategic decision-making.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="analyzeData">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-2"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-2" ? "" : "collapse-2"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      How do you analyze data to uncover hidden patterns and connections?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-2"}>
                  <CardBody className="text-white font-weight-normal">
                   We utilize advanced algorithms combined with human intelligence to analyze 
                   data, uncovering hidden patterns and connections that help identify trends, 
                   anomalies, and potential threats. This approach ensures the intelligence we 
                   provide is actionable and reliable.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="transactionMonitoring">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-3"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-3" ? "" : "collapse-3"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      What tools do you use for on-chain transaction monitoring?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-3"}>
                  <CardBody className="text-white font-weight-normal">
                    We utilize state-of-the-art tools and advanced analytics to scrutinize 
                    blockchain transactions, detect suspicious activities, trace the flow of 
                    funds, and identify potential threats.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="regulatoryRequirements">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-4"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-4" ? "" : "collapse-4"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      How do you ensure compliance with regulatory requirements?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-4"}>
                  <CardBody className="text-white font-weight-normal">
                    We assist organizations in meeting AML, KYC, KYB and CFT obligations, 
                    implementing monitoring systems to detect and report suspicious activities, 
                    and providing expert support for audits and regulatory reviews.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="threatIntelligence">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-5"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-5" ? "" : "collapse-5"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      What threat intelligence services do you offer?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-5"}>
                  <CardBody className="text-white font-weight-normal">
                    We deliver detailed intelligence on threats to security and financial 
                    assets, identifying potential threats, assessing their impact, and 
                    providing recommendations for proactive protection and risk management.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="undisclosedAssets">
                  <h3 className="text-white font-weight-bold">Asset Tracing and Recovery</h3>
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-6"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-6" ? "" : "collapse-6"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      How do you locate concealed or undisclosed assets?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-6"}>
                  <CardBody className="text-white font-weight-normal">
                    We utilize advanced techniques, including cross-border investigations 
                    and comprehensive financial analysis, to track the flow of funds and 
                    ensure effective asset recovery.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="trackingAssets">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-7"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-7" ? "" : "collapse-7"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      What methods do you use for tracking assets?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-7"}>
                  <CardBody className="text-white font-weight-normal">
                    We apply precise tracking methods and detailed analysis of transaction 
                    patterns and activity to ensure accuracy and thoroughness in asset recovery.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="howLong">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-8"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-8" ? "" : "collapse-8"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      How long does it take to resolve a financial crime case?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-8"}>
                  <CardBody className="text-white font-weight-normal">
                    The timeline for resolving a financial crime case can vary depending on the 
                    complexity of the case and the jurisdiction involved. Our team will work with 
                    you to provide a realistic timeline and keep you updated on progress 
                    throughout the process.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="isRecoveryGuaranteed">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-9"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-9" ? "" : "collapse-9"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Is asset recovery guaranteed?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-9"}>
                  <CardBody className="text-white font-weight-normal">
                    Asset recovery is complex and can be expensive. While we employ the best 
                    techniques and strategies, recovery is never guaranteed due to various factors, 
                    including jurisdictional challenges and the nature of the assets involved.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="areYouExperts">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-10"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-10" ? "" : "collapse-10"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      Are you experts at tracing blockchain and crypto assets?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-10"}>
                  <CardBody className="text-white font-weight-normal">
                    Yes, we are experts at tracing blockchain and crypto assets, utilizing 
                    sophisticated analytics and forensic techniques to track and recover 
                    misappropriated or stolen assets.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="dueDiligence">
                  <h3 className="text-white font-weight-bold">Due Diligence</h3>
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-11"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-11" ? "" : "collapse-11"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      What is involved in due diligence for crypto assets?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-11"}>
                  <CardBody className="text-white font-weight-normal">
                    We assess cryptocurrency projects, token offerings, and blockchain-based 
                    ventures, evaluating tokenomics, team capabilities, and market conditions 
                    to gauge investment potential and risk.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="KYCandKYB">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-12"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-12" ? "" : "collapse-12"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      How do you implement KYC and KYB processes?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-12"}>
                  <CardBody className="text-white font-weight-normal">
                    We conduct thorough verification and profiling to ensure compliance 
                    with regulatory requirements and effective risk management.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="corporateDueDiligence">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-13"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-13" ? "" : "collapse-13"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      What does corporate due diligence entail?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-13"}>
                  <CardBody className="text-white font-weight-normal">
                    We conduct comprehensive evaluations of potential business partners, 
                    investments, and acquisitions, performing detailed financial, reputational, 
                    and legal insights to support informed decision-making.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="supplyChain">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-14"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-14" ? "" : "collapse-14"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      How do you assess public perception and supply chain stability?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-14"}>
                  <CardBody className="text-white font-weight-normal">
                  We investigate the company&#8217;s reputation, including media coverage and 
                  public relations issues, and evaluate the supply chain to identify risks, 
                  dependencies, and potential PEPs or sanctioned entities.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="backgroundChecks">
                  <h3 className="text-white font-weight-bold">Private Investigations</h3>
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-15"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-15" ? "" : "collapse-15"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      What kind of background checks do you perform?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-15"}>
                  <CardBody className="text-white font-weight-normal">
                    We verify the credentials and history of individuals to ensure accuracy 
                    and reliability, supporting AML and CTF requirements through detailed 
                    background investigations.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="locateIndividuals">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-16"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-16" ? "" : "collapse-16"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      How do you locate individuals?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-16"}>
                  <CardBody className="text-white font-weight-normal">
                    We identify and track individuals, providing comprehensive locating services 
                    and gathering crucial information to support investigations and location efforts. 
                    Leading to actionable intelligence.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="surveillanceServices">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-17"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-17" ? "" : "collapse-17"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      What surveillance services do you offer?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-17"}>
                  <CardBody className="text-white font-weight-normal">
                    We conduct discreet surveillance and counter-surveillance to ensure client privacy 
                    and security, protecting clients from unauthorized surveillance and monitoring 
                    critical activities.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="monitorOnline">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-18"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-18" ? "" : "collapse-18"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      How do you monitor online activities?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-18"}>
                  <CardBody className="text-white font-weight-normal">
                   We track online activities, including social media and digital communications, to 
                   gather relevant information and monitor digital footprints.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="dueDiligenceInvestigations">
                  <h3 className="text-white font-weight-bold">Corporate Investigations</h3>
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-19"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-19" ? "" : "collapse-19"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      What is involved in due diligence investigations?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-19"}>
                  <CardBody className="text-white font-weight-normal">
                    We conduct thorough background checks on business partners and perform due diligence 
                    for mergers and acquisitions, assessing potential risks and ensuring compliance with 
                    regulatory standards.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="financialInvestigations">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-20"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-20" ? "" : "collapse-20"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      How do you conduct fraud and financial investigations?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-20"}>
                  <CardBody className="text-white font-weight-normal">
                    We examine financial discrepancies, money laundering, accounting anomalies, and 
                    potential fraud or theft, investigating financial crimes and recovering assets when possible.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="industrialEspionage">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-21"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-21" ? "" : "collapse-21"
                        )
                      }
                      className="w-100 text-info text-left collapsed"
                      color="link"
                      type="button"
                    >
                      How do you address industrial espionage and intellectual property theft?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-21"}>
                  <CardBody className="text-white font-weight-normal">
                    We detect and address corporate espionage activities and intellectual property theft, 
                    safeguarding business interests.
                  </CardBody>
                </Collapse>
              </Card>
              <Card className="bg-default">
                <CardHeader className="bg-default" id="employeeInvestigations">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-22"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-22" ? "" : "collapse-22"
                        )
                      }
                      className="w-100 text-info text-left"
                      color="link"
                      type="button"
                    >
                      What employee investigations do you perform?{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-22"}>
                  <CardBody className="text-white font-weight-normal">
                    We perform comprehensive background checks and investigate allegations 
                    of misconduct to maintain organizational integrity and safety.
                  </CardBody>
                </Collapse>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AccordionFAQs;
